import { getMessageFromErrorResponse, isBaseError } from '@/api/v4/base-fetch';

export const isInactiveAccountError = (error: unknown) => {
  if (isBaseError(error)) {
    const message = getMessageFromErrorResponse(error);
    return message === 'No active user';
  }

  return false;
};
